module.exports = __webpack_public_path__ + "img/outlander5.a437306a.jpeg";